import { Controller } from "@hotwired/stimulus";
import { useHotkeys } from "stimulus-use/hotkeys";
import { Turbo } from "@hotwired/turbo-rails";

// Connects to data-controller="site"
export default class extends Controller {
  static targets = ["navigation", "activeNavigationItem", "userPresenceModal", "globalSearchModal", "offlineIndicator"];

  connect() {
    this.detectNavigationHidden();
    this.detectActiveNavigationItem();
    useHotkeys(this, {
      "ctrl+b, command+b": [this.toggleNavigation]    
    });
  }

  detectNavigationHidden() {
    this.minimized =
      window.localStorage.getItem("navigationMinimized") === "true";
    if (this.minimized) {
      this.navigationTarget.classList.add("navigation-minimized");
    }
  }

  detectActiveNavigationItem() {
    if (this.hasActiveNavigationItemTarget) {
      this.activeNavigationItemTarget.scrollIntoView({
        behavior: "instant",
        block: "center",
      });
    }
  }

  toggleNavigation() {
    this.navigationTarget.classList.toggle("navigation-minimized");
    window.localStorage.setItem(
      "navigationMinimized",
      this.navigationTarget.classList.contains("navigation-minimized"),
    );
  }

  showUserPresenceModal(event) {
    if (event) event.stopPropagation();
    this.userPresenceModalTarget.classList.remove("hidden");
  }

  handlePresenceModalClick(event) {
    if (event && event.target.classList.contains("modal-bg")) {
      event.stopPropagation();
      this.userPresenceModalTarget.classList.add("hidden");
    }
  }

  launchGlobalSearch() {
    this.globalSearchModalTarget.click();
  }

  refreshPage() {
    Turbo.visit(window.location.href, { action: "replace" });
  }

  offline() {
    this.offlineIndicatorTarget?.classList.remove("hidden")
  }

  online() {
    this.offlineIndicatorTarget?.classList.add("hidden")
  }
  
}
